import type { GltfLoadingOptions } from '@/plugins/mesh/types'

/** 防御性地把尚未预解析的 auto 转为最小有限档位，避免创建全尺寸图片。 */
export function getConcreteGltfTextureMaxSize(loading: GltfLoadingOptions): number {
  if (typeof loading.texture.maxSize === 'number') return loading.texture.maxSize
  const sizes = loading.texture.autoSize.candidateSizes.filter(
    (size) => Number.isInteger(size) && size > 0
  )
  if (sizes.length === 0) throw new RangeError('glTF 自动纹理至少需要一个正整数候选')
  return Math.min(...sizes)
}
